import { Button, makeStyles, TextField } from '@material-ui/core/';
import * as React from 'react';
import sendQuestion from '../actions/sendQuestion';
import useStore from '../store/store';

const ContactUsPage = () => {
    const setTitle = useStore((state) => state.setTitle);
    const classes = useStyles({});
    const email = useStore((state) => state.email);
    const formRef = React.useRef<HTMLFormElement>(null);
    const isLoading = useStore((state) => state.isLoading);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const target = e.currentTarget as typeof e.currentTarget & {
            title: { value: string };
            content: { value: string };
            sender?: { value: string };
        };

        const title = target.title.value.trim();
        const content = target.content.value.trim();
        const sender = target.sender?.value?.trim();

        const payload: { title: string; content: string; sender?: string } = {
            title,
            content,
        };
        if (sender) {
            payload.sender = sender;
        }

        await sendQuestion(payload);
        formRef.current?.reset();
    };

    React.useEffect(() => {
        setTitle('Genome Portal - Contact Us');
    }, [setTitle]);

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <div className={classes.title}>Contact Us</div>
            </div>

            <form
                ref={formRef}
                onSubmit={handleSubmit}
                style={{ width: '100%' }}
            >
                <TextField
                    margin="dense"
                    id="title"
                    name="title"
                    label="Title"
                    type="text"
                    fullWidth
                    variant="outlined"
                    required
                />

                <TextField
                    margin="dense"
                    id="content"
                    name="content"
                    label="Content"
                    type="text"
                    fullWidth
                    variant="outlined"
                    required
                    multiline
                    minRows={4}
                />

                <TextField
                    margin="dense"
                    id="sender"
                    name="sender"
                    label="Sender"
                    type="email"
                    fullWidth
                    variant="outlined"
                    required={!email}
                    defaultValue={email}
                />

                <div className={classes.actions}>
                    <Button
                        type="submit"
                        className={classes.button}
                        disabled={isLoading}
                    >
                        Submit
                    </Button>
                </div>
            </form>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        padding: '40px',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 0 0',
        alignSelf: 'stretch',
        background: '#fff',
        maxWidth: '600px',
        margin: '40px auto 0',
        borderRadius: '20px',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '27px',
    },
    title: {
        display: 'flex',
        color: theme.palette.primary.main,
        fontFamily: 'Poppins',
        fontSize: '32px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.576px',
        marginBottom: '20px',
    },
    actions: {
        paddingTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
    },
    button: {
        display: 'flex',
        height: '36px',
        padding: '4px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '25px',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '150%',
        letterSpacing: '-0.14px',
        textTransform: 'none',
    },
}));

export default ContactUsPage;
